export const PDFDocumentTypes = {
	RentalcarContract: 'rentalcar_contract',
	DamageAccessor: 'damage_accessor',
	LawyerPaymentOrder: 'lawyer_payment_order',
	Workingimages: 'workingimages',
	RepairProof: 'repair_proof',
	DamagecaseAll: 'damagecase_all',
	Repairplan: 'repairplan',
	ReparaturAuftrag: 'Reparatur-Auftrag',
	LawyerMandate: 'lawyer_mandate',
	PaymentReminderWithoutLawyer: 'payment_reminder_customer_without_lawyer',
	PaymentReminderWithLawyer: 'payment_reminder_customer_with_lawyer',
	SecondPaymentReminderWithoutLawyer: 'second_payment_reminder_customer_without_lawyer',
	SecondPaymentReminderWithLawyer: 'second_payment_reminder_customer_with_lawyer',
	DunningLast: 'dunning_notice_last',
	DunningFirst: 'dunning_notice',
	Nebenleistungen: 'nebenleistungen',
	PaymentOrderAssignment: 'payment_order_assignment',
	RepairOrderDocumentation: 'repair-order-documentation',
	MaintenanceTOC: 'connect_toc',
};
